import { render, staticRenderFns } from "./ButtonsLayout.vue?vue&type=template&id=286a08f0&scoped=true&"
import script from "./ButtonsLayout.vue?vue&type=script&lang=js&"
export * from "./ButtonsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsLayout.vue?vue&type=style&index=0&id=286a08f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a08f0",
  null
  
)

export default component.exports